import { getUserBaseInfo, getUserAuthInfo, getECardTypes, getCbChannel, getSysnotice } from './api'

export const SET_SIDER = 'sider';
export const SET_USER_INFO = 'userInfo';
export const SET_BREADCRUMB = 'breadcrumb';
export const SET_CARDTYPE = 'cardType';
export const SET_PAYCHANNEL = 'payChannel';
export const SET_ORGLIST = 'orgList';
export const SET_SYSNOTICE = 'sysnotice';


export const fetchUserBaseInfo = (orgId) => {
    return async (dispatch, getState) => {
        let userInfo = await getUserBaseInfo();
        dispatch({
            type: SET_USER_INFO,
            userInfo
        })
    }
}

export const fetchUserAuthInfo = (orgId) => {
    return async (dispatch, getState) => {
        let { appRs: { userInfo } } = await getState()
        let authInfo = await getUserAuthInfo(userInfo.identity, orgId);
        let sysnotice = await getSysnotice(orgId);
        Object.assign(userInfo, authInfo)
        let cardType = await getECardTypes(userInfo.identity, orgId);
        let payChannel = await getCbChannel(userInfo.identity, orgId);
        dispatch({
            type: SET_USER_INFO,
            userInfo
        })
        dispatch({
            type: SET_SYSNOTICE,
            sysnotice
        })
        dispatch({
            type: SET_CARDTYPE,
            cardType
        })
        dispatch({
            type: SET_PAYCHANNEL,
            payChannel
        })
    }
}



// WEBPACK FOOTER //
// ./src/App.action.js